import { Component, OnInit } from '@angular/core';
import { PsAcuerdoBasicoService } from '../../../services/ps-acuerdo-basico.service';
import { ActivatedRoute } from '@angular/router';
import { PsAcuerdoPosteriorService } from '../../../services/ps-acuerdo-posterior.service';

@Component({
  selector: 'app-ps-acuerdos-list',
  templateUrl: './ps-acuerdos-list.component.html',
  styleUrls: ['./ps-acuerdos-list.component.scss']
})
export class PsAcuerdosListComponent implements OnInit {

  acuerdosBasicosList: any;
  acuerdosPosterioresList: any;
  hasAcuerdosPosteriores = false;
  idPs: number;

  constructor(private _psAcuerdoBasicoService: PsAcuerdoBasicoService, private _psAcuerdoPosterioroService: PsAcuerdoPosteriorService,
    private _avRoute: ActivatedRoute) {
    if (this._avRoute.snapshot.params['id']) {
      this.idPs = this._avRoute.snapshot.params['id'];
    }
  }

  ngOnInit() {

    this.loadData();
  }

  loadData() {
    this._psAcuerdoBasicoService.getAllById(this.idPs).subscribe((resp) => {
      console.log(resp)
      this.acuerdosBasicosList = resp;
    })

    this._psAcuerdoPosterioroService.getAllById(this.idPs).subscribe((resp) => {
      console.log(resp)
      this.acuerdosPosterioresList = resp;

      if (this.acuerdosPosterioresList.length > 0) {
        this.hasAcuerdosPosteriores = true;
      }
    })
  }

  reLoadAcuerdoBasicoPromise() {
    const psAcuerdoBasico = this._psAcuerdoBasicoService.getAllById(this.idPs).toPromise();
    this.acuerdosBasicosList = psAcuerdoBasico;
  }

}


